import axiosPrivate from "./axiosPrivate";

const getTareasGantt = (area_id, mes, estado, responsable) => {
    return axiosPrivate.get("gantt-tareas", {
        params: { area_id, mes, estado, responsable }
    }).then(response => response.data);
};

const insertTareaGantt = (data) => {
    return axiosPrivate.post("gantt-tareas", data)
        .then(response => response.data);
};

const updateTareaGantt = (data) => {
    return axiosPrivate.put("gantt-tareas", data)
        .then(response => response.data);
};

const deleteTareaGantt = (data) => {
    return axiosPrivate.delete("gantt-tareas", { data })
        .then(response => response.data);
};

const getUsuariosArea = (area_id) => {
    return axiosPrivate.get('gantt-tareas/usuarios', { params: { area_id } })
        .then(response => response.data);
};

export default {
    getTareasGantt,
    insertTareaGantt,
    updateTareaGantt,
    deleteTareaGantt,
    getUsuariosArea,
};
